import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AdminLayout from '../AdminLayout';
import { Row, Col, Table, Modal, Tag, message } from 'antd';
import * as actions from './../redux/actions';
import * as actionsUser from '../../user/redux/actions';
import { API } from '../../../helper/api';
import moment from 'moment';
import { STATUS, is } from './Constants';
import * as eventService from '../../../helper/event/statusHelper';
import { UserAdd } from './UserAdd';


const columns = [{
  title: 'Etudiant',
  dataIndex: 'fullName'
}, {
  title: 'Classe',
  dataIndex: 'promotion',
  key: 'classe',
  render: (promotion) => <Tag>{promotion.name}</Tag>
}, {
  title: 'Classe Description',
  dataIndex: 'promotion',
  key: 'description',
  render: (promotion) => <Tag>{promotion.description}</Tag>
}, {
  title: 'Point Jury',
  dataIndex: 'totalJuryPoints',
  render: (point) => !point ? 0 : point
}, {
  title: 'Age',
  dataIndex: 'dateOfBirth',
  render: (date) => moment().diff(date, 'years')
}];

export class UsersRegistration extends Component {
  static propTypes = {
    admin: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    event: {},
    user: [],
    loadingEvent: true,
    loading: true,
    selected: [],
    visibleModal: false,
    currentlyAdding: false
  }

  confirmUsers(status) {
    this.state.selected.map(id =>
      API.post('Booking/confirm/' + id + '/' + this.props.match.params.id + '/' + status)
        .then((res) => this.getUsers())
        .then((res) => this.setState({ selected: [] }))
        .then(() => message.success(status ? "Inscription(s) confirmé(s)" : "Rejet(s) appliqué(s)"))
        .catch(() => message.error("Action impossible"))
    )
  }

  onChange = (selectedRowKeys, selectedRows) => {
    this.setState({ selected: selectedRows.map(u => u.id) })
  }

  getUsers() {
    this.setState({ loading: true })
    API.get('Booking/users_status/' + this.props.match.params.id)
      .then((res) => this.setState({ user: res.data, loading: false, selected: [] }))
  }

  closeSubscriptions(){
    API.patch('event/'+this.props.match.params.id, { endAt : moment().format()})
      .then(() => this.setState({ event: { ...this.state.event, status:  STATUS.INCOMING}}));
  }

  componentDidMount(){
    API.get('event/' + this.props.match.params.id)
      .then(res => res.data.event)
      .then(event => this.setState({ event, loadingEvent: false }))
    this.getUsers();
    this.props.actions.getUsers();
  }

  addUser(user) {
    this.setState({currentlyAdding:true});
    API.post('Booking/user/', { userId: user.id, eventId: this.props.match.params.id })
      .then((res) => {
        this.setState({ currentlyAdding: false });
        this.getUsers();
      });
  }

  render() {
    const { event } = this.state;
    let buttons = [
      {
        icon: "plus",
        name: "AJOUTER",
        onClick: () => this.setState({visibleModal : true})
      }
    ];

    if( eventService.isFencable(event) ) {
      buttons.push({
        icon: "cloud-upload",
        type: "dashed",
        name: "CLOTURER LES INSCRIPTIONS",
        confirmation: 'true',
        onClick: () => this.closeSubscriptions()
      });
    }

    if( eventService.isPensionable(event) ) {
      buttons.push({
        icon: "check",
        type: "dashed",
        name: "PRESENCE",
        onClick: () => this.props.history.push('/admin/events/presence/'+this.props.match.params.id)
      });
    }

    if (event.validationRequired) {
      buttons.push({
        icon: "cloud-upload",
        name: "VALIDER",
        onClick: () => this.confirmUsers(true)
      });
      buttons.push({
        icon: "delete",
        name: "REJETER",
        confirmation: "true",
        type: "danger",
        onClick: () => this.confirmUsers(false)
      });
    }

    return (
      <div className="UserPresence-content">
        <AdminLayout
          title={event.title ? event.title + " - INSCRIPTION" : "INSCRIPTION"}
          back="/admin/events"
          loading={this.state.loadingEvent}
          buttons={buttons}
        >
          {event.validationRequired ?
            <div className="UserRegistration-content">
              <Row>
                <Row style={{ width: '100%' }} type="flex" justify="start">
                  <Col span={24} style={{ margin: '20px 0 20px 10px' }}>
                    <h1>INSCRIPTIONS VALIDÉES <Tag color="#87d068" style={{ float: 'left' }}>{this.state.user.filter(u => u.validated === true).length}</Tag></h1>
                  </Col>
                </Row>
                <Table
                  rowSelection={{ onChange: this.onChange }}
                  loading={this.state.loading}
                  columns={columns}
                  pagination={false}
                  dataSource={this.state.user.filter(u => u.validated === true).map(u => u.user)} />
              </Row>
              <Row>
                <Row style={{ width: '100%' }} type="flex" justify="start">
                  <Col span={24} style={{ margin: '20px 0 20px 10px' }}>
                    <h1>INSCRIPTIONS <Tag color="red" style={{ float: 'left' }}>{this.state.user.filter(u => u.validated === false).length}</Tag></h1>
                  </Col>
                </Row>
                <Table
                  rowSelection={{ onChange: this.onChange }}
                  columns={columns}
                  loading={this.state.loading}
                  pagination={false}
                  dataSource={this.state.user.filter(u => u.validated === false).map(u => u.user)} />
              </Row>
            </div>
            :
            <Row className="UserRegistration-content">
              <Row style={{ width: '100%' }} type="flex" justify="start">
                <Col span={24} style={{ margin: '20px 0 20px 10px' }}>
                  <h1>INSCRIPTIONS <Tag color="#87d068" style={{ float: 'left' }}>{this.state.user.filter(u => u.validated === null).length}</Tag></h1>
                </Col>
              </Row>
              <Table
                columns={columns}
                loading={this.state.loading}
                pagination={false}
                dataSource={this.state.user.filter(u => u.validated === null).map(u => u.user)} />
            </Row>
          }
        </AdminLayout>
          <Modal
            className="modal-add-user"
            visible={this.state.visibleModal}
            onOk={() => this.setState({visibleModal : false})}
            onCancel={() => this.setState({visibleModal : false})}
            footer={null}
            width={800}
          >
            <UserAdd
              users={this.props.user.list}
              loading={this.props.user.status.getUsers.pending}
              addUser={(record) => this.addUser(record)}
              inscriptions={this.state.user}
              adding={this.state.currentlyAdding}
            />
          </Modal>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    admin: state.admin,
    user: state.user,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...actionsUser }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsersRegistration);


// WEBPACK FOOTER //
// ./src/features/admin/events/UsersRegistration.js